import "./App.css";
import "@shopify/polaris/build/esm/styles.css";
import { AppProvider, Spinner } from "@shopify/polaris";
import "@shopify/discount-app-components/build/esm/styles.css";
import { AppBridgeState, ClientApplication, createApp } from "@shopify/app-bridge";
import { BrowserRouter } from "react-router-dom";
import { Suspense, useEffect, useState } from "react";
import AppContextProvider from "./context/AppConfigContext";
import "./utilities/customAxios";
import mixpanel from "mixpanel-browser";
import { ShowOnboardingProvider } from "./context/ShowOnboardingContext";
import RoutesWrapper from "./RoutesWrapper";
import CustomResourcePicker from "./components/CustomResourcePicker";
import ErrorBoundary from "./ErrorBoundary";
import useNumberInputDragPropagationGuard from "./hooks/useNumberInputDragPropagationGuard";
export let EmbeddedApp: ClientApplication<AppBridgeState>;
import enTranslations from "@shopify/polaris/locales/en.json";

import * as Sentry from "@sentry/react";
import { SentryDSN } from "./config";
import { StoresWithSwatches } from "./utilities/constants";
import { initDeferredScripts } from "./utilities/functions";
import { LoadingScreen } from "./components/LoadingScreen/LoadingScreen";

Sentry.init({
    dsn: SentryDSN,
});

console._log("Sentry DSN", SentryDSN);

window.isKefiAdmin = true;

function App() {
    const [appBridgeReady, setAppBridgeReady] = useState(false);
    useNumberInputDragPropagationGuard();

    useEffect(() => {
        (async () => {
            if (window.shopify) {
                await shopify.ready;
                if (shopify.config.host) {
                    const app = createApp({
                        apiKey: shopify.config.apiKey,
                        host: shopify.config.host,
                    });
                    EmbeddedApp = app;
                    setAppBridgeReady(true);
                }
            } else {
                window.location.replace("https://admin.shopify.com/apps/kefi-bundles-app");
            }
        })();
    }, []);

    useEffect(() => {
        if (appBridgeReady && shopify?.config?.shop) {
            Sentry.setUser({ id: window.shopify.config.shop });
            mixpanel.identify(shopify.config.shop);
            window.swatches_available = StoresWithSwatches.includes(window.shopify.config.shop || "");

            mixpanel.register({
                "Host Name": window.location.hostname,
                "User Id": shopify.config.shop,
            });
            //user properties
            mixpanel.people.set({
                $email: shopify.config.shop,
                $name: shopify.config.shop,
            });

            initDeferredScripts();
        }
    }, [appBridgeReady]);

    return (
        <AppProvider i18n={enTranslations}>
            {appBridgeReady ? (
                <>
                    <AppContextProvider>
                        <CustomResourcePicker />
                        <ShowOnboardingProvider>
                            <ErrorBoundary>
                                <Suspense fallback={<LoadingScreen />}>
                                    <BrowserRouter>
                                        <RoutesWrapper />
                                    </BrowserRouter>
                                </Suspense>
                            </ErrorBoundary>
                        </ShowOnboardingProvider>
                    </AppContextProvider>
                </>
            ) : (
                <LoadingScreen />
            )}
        </AppProvider>
    );
}

export const Loader = () => {
    return (
        <div className="loader">
            <Spinner />
        </div>
    );
};

export default App;
